import * as yup from 'yup';
import { useTranslations } from 'hooks/useTranslations';

const useCalibreFormSchema = () => {
  const { t } = useTranslations();
  const schema = yup.object({
    caliberUniqueId: yup
      .string()
      .required(t('general.field.validation.required'))
      .max(64, t('general.field.validation.maxCharacters').replace('%s', '64'))
      .trim(),
    barrelLength: yup
      .string()
      .required(t('general.field.validation.required'))
      .matches(/^[0-9]+([.,][0-9]+)?$/, t('general.field.validation.onlyDigits'))
      .max(9, t('general.field.validation.maxDigits').replace('%s', '9'))
      .trim(),
    shots: yup
      .string()
      .required(t('general.field.validation.required'))
      .matches(/^[0-9]+$/, t('general.field.validation.onlyDigits'))
      .max(3, t('general.field.validation.maxDigits').replace('%s', '3'))
      .trim(),
    barrelTypeUniqueId: yup.string(),
  });
  return { schema };
};

export default useCalibreFormSchema;
